export enum FormQuestionType {
  Single,
  Multi,
  Open,
  Scale,
  Map
}
